import * as React from "react";
const EventsSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="rgba(238, 65, 55, 1)"
      d="M14.5 18c-.7 0-1.292-.242-1.775-.725C12.242 16.792 12 16.2 12 15.5s.242-1.292.725-1.775C13.208 13.242 13.8 13 14.5 13s1.292.242 1.775.725c.483.483.725 1.075.725 1.775s-.242 1.292-.725 1.775c-.483.483-1.075.725-1.775.725ZM5 22c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 0 1 3 20V6c0-.55.196-1.02.588-1.412A1.93 1.93 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v14c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Z"
    />
  </svg>
);
export default EventsSVG;
